import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface FootballState {
  metaDataIdx: number;
  packIdx: number;
}

const initialState: FootballState = {
  metaDataIdx: -1,
  packIdx: -1,
};

const footballSlice = createSlice({
  name: 'football',
  initialState,
  reducers: {
    // 플립 카드 인덱스 설정
    setFlippableCardIdx(
      state,
      action: PayloadAction<{
        metaDataIdx: number;
        packIdx: number;
      }>,
    ) {
      state.metaDataIdx = action.payload.metaDataIdx;
      state.packIdx = action.payload.packIdx;
    },
    // 플립 카드 인덱스 초기화
    resetFlippableCardIdx(state) {
      state.metaDataIdx = -1;
      state.packIdx = -1;
    },
  },
});

export const footballActions = footballSlice.actions;

export default footballSlice;
